export default {
  year: '',
  month: '',
  day: '',
  hour: '',
  minute: '',
  am: 'AM',
  pm: 'PM'
}



// WEBPACK FOOTER //
// ./src/components/mobile-date-picker/locale/en_US.js